import { gql } from 'graphql-request'

export const GET_TOTAL_STATUS = gql`
  query Query($statusType: WriterStatusAdminEnum, $searchText: String) {
    findUserWriters(statusType: $statusType, searchText: $searchText) {
      total
    }
  }
`
